import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import BottomNavigation from './components/BottomNavigation';
import Footer from './components/Footer';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import Home from './pages/Home';
import Services from './pages/Services';
import Products from './pages/Products';
import VendorProfile from './pages/VendorProfile';
import VendorDashboard from './pages/VendorDashboard';
import VendorEditProfile from './pages/VendorEditProfile';
import AddListing from './pages/AddListing';
import EditService from './pages/EditService';
import ViewService from './pages/ViewService';
import Auth from './pages/Auth';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminAddVendor from './pages/AdminAddVendor';
import AdminEditVendor from './pages/AdminEditVendor';
import './styles/main.css';
import AdminAddService from './components/AdminAddService';
import AdminEditService from './components/AdminEditService';

function AppContent() {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState('/');

  useEffect(() => {
    setCurrentPage(location.pathname);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  // Don't show Navigation, Footer, and BottomNavigation on admin pages or login
  const isAdminPage = location.pathname.startsWith('/admin') || location.pathname === '/admin-login';

  return (
    <div className="App">
      {!isAdminPage && <Navigation currentPage={currentPage} />}
      <main
      // style={{paddingBottom: '80px'}}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/products" element={<Products />} />
          <Route path="/vendor/:id" element={<VendorProfile />} />
          <Route path="/vendor-dashboard" element={<VendorDashboard />} />
          <Route path="/vendor-edit-profile" element={<VendorEditProfile />} />
          <Route path="/add-listing" element={<AddListing />} />
          <Route path="/edit-service/:serviceId" element={<EditService />} />
          <Route path="/service/:serviceId" element={<ViewService />} />
          <Route path="/auth" element={<Auth />} />
          
          {/* Admin Routes */}
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedAdminRoute>
                <AdminDashboard />
              </ProtectedAdminRoute>
            }
          />

          <Route
            path="/admin/vendors/add"
            element={
              <ProtectedAdminRoute>
                <AdminAddVendor />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/vendors/edit/:id"
            element={
              <ProtectedAdminRoute>
                <AdminEditVendor />
              </ProtectedAdminRoute>
            }
          />

          <Route
            path="/admin/services/add"
            element={
              <ProtectedAdminRoute>
                <AdminAddService />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/services/edit/:id"
            element={
              <ProtectedAdminRoute>
                <AdminEditService />
              </ProtectedAdminRoute>
            }
          />
        </Routes>
      </main>
      {!isAdminPage && <Footer />}
      {!isAdminPage && <BottomNavigation currentPage={currentPage} />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;